import { Inbox, Search } from 'react-bootstrap-icons';

import { Button } from '../buttons';

interface EmptyStateProps {
  /** Пусто ИЗ-ЗА запроса (активен локальный поиск/фильтры), а не «данных нет». */
  hasQuery: boolean;
  noDataText: string;
  /**
   * Кнопка «Сбросить» при hasQuery: стейт поиска/фильтров живёт на странице,
   * чистит его страница; без колбэка кнопки нет (только подсказка).
   */
  onFiltersClear?: () => void;
}

/**
 * Умное пустое состояние DataTableV2: иконка + причина. При активном локальном
 * поиске/фильтрах — лупа, подсказка «измените условия…» и кнопка «Сбросить»
 * (если страница дала колбэк); когда данных просто нет — «пустой ящик» без
 * подсказки. Используется и строкой no-data dx-темы, и блоком custom-темы.
 */
const DataTableV2EmptyState = ({ hasQuery, noDataText, onFiltersClear }: EmptyStateProps) => (
  <div className='d-flex flex-column align-items-center py-4 text-muted'>
    { hasQuery ? <Search size={ 36 } /> : <Inbox size={ 36 } /> }

    <div className='mt-2'>{ noDataText }</div>

    { hasQuery && (
      <>
        <div className='small mt-1'>Измените условия поиска или сбросьте фильтры</div>

        { onFiltersClear && (
          <Button
            variant='outline-secondary'
            size='sm'
            className='mt-3'
            onClick={ onFiltersClear }
          >
            Сбросить
          </Button>
        ) }
      </>
    ) }
  </div>
);

export default DataTableV2EmptyState;
